import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

    fYear:any = [];
    financialYear:any;
    currentYear:any = new Date().getFullYear();
  constructor() { }

  ngOnInit(): void {

    if(sessionStorage.getItem('currentFYear')){
this.financialYear = sessionStorage.getItem('currentFYear');
    }
    this.generateFYear();
  }
  generateFYear(){
    for(let i = this.currentYear - 5; i < this.currentYear ;i++){
        this.fYear.push({'year':i+'','id':i});
    }
    for(let i = this.currentYear ; i <= this.currentYear+5 ; i++){
        this.fYear.push({'year':i+'','id':i});
    }
}

  setFYear(){
    sessionStorage.setItem('currentFYear',this.financialYear);
  }
}
